// extracted by mini-css-extract-plugin
module.exports = {"root":"eight_root__3ZC1t","check":"eight_check__1vt0J"};